import  { useState } from 'react'

export const OnboardXState = () => {
    const [profile, setProfile] = useState(false)
    const [ready, setReady] = useState(false)
    const [set, setSet] = useState(false)
    const [go, setGo] = useState(false)
    const [save, setSave] = useState(false)
    const [list, setList] = useState ([])
    const [profileRead, setProfileRead] = useState([])
    const [profileLoader, setProfileLoader] = useState(false)
    const [viewLoader, setViewLoader] = useState(false)
    const [deptRes, setDepRes] = useState([])
    // const [superior, setSuperior] = useState([])
    const [superiorId, setSuperiorId] = useState([])  
    const [peerId, setPeerId] = useState([])
    const [deptId, setDeptId] = useState([])
    const [users, setUsers] = useState([])
    const [onboardDate, setOnboardDate] = useState([])
    const [project, setProject] = useState([])
    const [client, setClient] = useState([])
    const [projectRead, setProjectRead] = useState([])
    const [clientRead, setClientRead] = useState([])
    const [onboardRes, setOnboardRes] = useState([])
    const [updateLoader, setUpdateLoader] = useState(false)
    const [onboard, setOnboard] = useState ({
      type:'create',
      inputs:{
        project: {value: '', stat: false, msg: '', toggled: false},
        client_id: {value: '', stat: false, msg: '', toggled: false},
        client_name: {value: '', stat: false, msg: '', toggled: false},
        project_id: {value: '', stat: false, msg: '', toggled: false},
        project_name: {value: '', stat: false, msg: '', toggled: false},
        department: {value: '',id:'', stat: false, msg: '', toggled: false},
        first_name: {value: '', stat: false, msg: '', toggled: false},
        last_name: {value: '', stat: false, msg: '', toggled: false},
        onboarding_data:{value:'', stat: false, msg: '', toggled: false},
      }
  })


  return {
    profile: {data: profile, set: setProfile},
    ready: {data: ready, set: setReady},
    set: {data: set, set: setSet},
    go: {data: go, set: setGo},
    save: {data: save, set: setSave},
    list:{data: list, set:setList},
    profileRead:{data:profileRead, set:setProfileRead},
    profileLoader:{data:profileLoader, set:setProfileLoader},
    deptRes:{data:deptRes, set:setDepRes},
    // superior:{data:superior, set:setSuperior},
    superiorId:{data:superiorId, set:setSuperiorId},
    peerId:{data:peerId, set:setPeerId},
    deptId:{data:deptId, set:setDeptId},
    users:{data:users, set:setUsers},
    onboard:{data:onboard, set:setOnboard},
    project:{data:project, set:setProject},
    projectRead:{data:projectRead, set:setProjectRead},
    client:{data:client, set:setClient},
    clientRead:{data:clientRead, set:setClientRead},
    onboardDate:{data:onboardDate, set:setOnboardDate},
    onboardRes:{data:onboardRes, set:setOnboardRes},
    viewLoader:{data:viewLoader, set:setViewLoader},
    updateLoader:{data:updateLoader, set:setUpdateLoader}
}
  
}
